import React, { memo, useState, useCallback } from "react";
import { IconSend } from "@tabler/icons-react";
import { NOTE_TYPES, NOTE_TYPE_CONFIG } from "../../utils/constants";
import "./NoteForm.css";

/**
 * Formulário para criar nova nota
 */
const NoteForm = memo(({ onSubmit, isSubmitting = false }) => {
  const [content, setContent] = useState("");
  const [type, setType] = useState(NOTE_TYPES.GENERAL);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    const trimmedContent = content.trim();
    if (!trimmedContent) return;

    onSubmit?.({ content: trimmedContent, type });
    setContent("");
    setType(NOTE_TYPES.GENERAL);
  }, [content, type, onSubmit]);

  const noteTypes = [
    { value: NOTE_TYPES.GENERAL, ...NOTE_TYPE_CONFIG[NOTE_TYPES.GENERAL] },
    { value: NOTE_TYPES.IMPORTANT, ...NOTE_TYPE_CONFIG[NOTE_TYPES.IMPORTANT] },
    { value: NOTE_TYPES.WARNING, ...NOTE_TYPE_CONFIG[NOTE_TYPES.WARNING] },
    { value: NOTE_TYPES.FOLLOW_UP, ...NOTE_TYPE_CONFIG[NOTE_TYPES.FOLLOW_UP] },
  ];

  return (
    <form className="sc-note-form" onSubmit={handleSubmit}>
      {/* Seletor de tipo */}
      <div className="sc-note-form__types">
        {noteTypes.map((noteType) => (
          <button
            key={noteType.value}
            type="button"
            className={`sc-note-form__type-btn ${type === noteType.value ? "active" : ""}`}
            style={{
              "--type-color": noteType.color,
              "--type-bg": noteType.bgColor,
            }}
            onClick={() => setType(noteType.value)}
          >
            <span className="sc-note-form__type-icon">{noteType.icon}</span>
            {noteType.label}
          </button>
        ))}
      </div>

      {/* Campo de texto */}
      <div className="sc-note-form__input-wrapper">
        <textarea
          className="sc-note-form__input"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Escreva uma nota sobre este contato..."
          rows={3}
          disabled={isSubmitting}
        />
        <button
          type="submit"
          className="sc-note-form__submit"
          disabled={!content.trim() || isSubmitting}
        >
          <IconSend size={18} />
        </button>
      </div>
    </form>
  );
});

NoteForm.displayName = "NoteForm";

export default NoteForm;
